<div class="bg-white shadow-lg rounded-xl w-full overflow-hidden">
    <div class="min-h-2 w-full relative shadow-sm" (click)="toggleCard()">
        @if (headerTemplate) {
          <ng-template [ngTemplateOutlet]="headerTemplate"></ng-template>
        }
        <span [style.color]="iconColor">
            <vw-chevron-right-icon [ngClass]="{'rotate-90': isExpanded}"
                class="transition-transform duration-300 absolute right-3 top-1/2 -translate-y-1/2"></vw-chevron-right-icon>
        </span>
    </div>
    @if (isExpandable) {
      <div #content class="overflow-hidden transition-all duration-300"
          [style.height]="isExpanded ? content.scrollHeight + 'px' : '0'">
          @if (bodyTemplate) {
            <ng-template [ngTemplateOutlet]="bodyTemplate"></ng-template>
          }
      </div>
    }
</div>